var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 175C59.3774 175 25.8 141.423 25.8 100C25.8 58.5774 59.3774 25 100.8 25C142.223 25 175.8 58.5774 175.8 100C175.8 141.423 142.223 175 100.8 175Z",
    fill: "url(#paint0_linear_26801_1039)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1499 150.046C83.1241 150.046 81.4817 148.405 81.4817 146.378V131.705C81.4817 129.677 83.1241 128.037 85.1499 128.037C87.1756 128.037 88.8181 129.677 88.8181 131.705V146.378C88.8181 148.405 87.1756 150.046 85.1499 150.046Z",
    fill: "url(#paint1_linear_26801_1039)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1502 135.373C62.901 135.373 44.8 117.272 44.8 95.0232C44.8 92.9956 46.4425 91.355 48.4682 91.355C50.494 91.355 52.1364 92.9956 52.1364 95.0232C52.1364 113.228 66.9471 128.037 85.1502 128.037C103.353 128.037 118.164 113.228 118.164 95.0232C118.164 92.9956 119.805 91.355 121.832 91.355C123.86 91.355 125.5 92.9956 125.5 95.0232C125.5 117.272 107.399 135.373 85.1502 135.373Z",
    fill: "url(#paint2_linear_26801_1039)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1481 40C70.9893 40 59.4707 51.5204 59.4707 65.6774V95.023C59.4707 109.18 70.9893 120.7 85.1481 120.7C99.3068 120.7 110.825 109.18 110.825 95.023V65.6774C110.825 51.5204 99.3068 40 85.1481 40Z",
    fill: "url(#paint3_linear_26801_1039)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.491 150.046H66.8091C64.7833 150.046 63.1409 148.405 63.1409 146.378C63.1409 144.35 64.7833 142.709 66.8091 142.709H103.491C105.519 142.709 107.159 144.35 107.159 146.378C107.159 148.405 105.519 150.046 103.491 150.046Z",
    fill: "url(#paint4_linear_26801_1039)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4707 80.3503C59.4707 78.3244 61.113 76.6821 63.1389 76.6821H107.157C109.183 76.6821 110.825 78.3244 110.825 80.3503C110.825 82.3762 109.183 84.0185 107.157 84.0185H63.1389C61.113 84.0185 59.4707 82.3762 59.4707 80.3503Z",
    fill: "url(#paint5_linear_26801_1039)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.832 76.6819C123.857 76.6819 125.5 75.0396 125.5 73.0137C125.5 70.9878 123.857 69.3455 121.832 69.3455C119.806 69.3455 118.163 70.9878 118.163 73.0137C118.163 75.0396 119.806 76.6819 121.832 76.6819Z",
    fill: "url(#paint6_linear_26801_1039)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.504 76.6821C134.477 76.6821 132.836 75.0415 132.836 73.0139C132.836 66.9456 127.9 62.0093 121.832 62.0093C119.804 62.0093 118.163 60.3687 118.163 58.3411C118.163 56.3136 119.804 54.6729 121.832 54.6729C131.944 54.6729 140.173 62.9013 140.173 73.0139C140.173 75.0415 138.532 76.6821 136.504 76.6821Z",
    fill: "url(#paint7_linear_26801_1039)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.177 76.682C149.15 76.682 147.509 75.0413 147.509 73.0138C147.509 58.8568 135.988 47.3364 121.832 47.3364C119.804 47.3364 118.163 45.6957 118.163 43.6682C118.163 41.6407 119.804 40 121.832 40C140.036 40 154.845 54.8089 154.845 73.0138C154.845 75.0413 153.205 76.682 151.177 76.682Z",
    fill: "url(#paint8_linear_26801_1039)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.492 161.3H141.35H139.696H139.339V153.062H142.033C142.716 153.062 143.12 152.285 142.716 151.726L137.475 144.474C137.141 144.008 136.45 144.008 136.117 144.474L130.875 151.726C130.472 152.285 130.868 153.062 131.559 153.062H134.253V161.3H133.896H132.242H125.122C121.045 161.075 117.8 157.262 117.8 153.131C117.8 150.282 119.345 147.797 121.636 146.454C121.426 145.887 121.317 145.281 121.317 144.645C121.317 141.733 123.67 139.38 126.582 139.38C127.211 139.38 127.816 139.489 128.383 139.699C130.068 136.127 133.702 133.65 137.926 133.65C143.392 133.658 147.895 137.843 148.408 143.177C152.609 143.899 155.8 147.789 155.8 152.192C155.8 156.897 152.135 160.974 147.492 161.3Z",
    fill: "url(#paint9_linear_26801_1039)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1039",
    x1: 25.8,
    y1: 36.7188,
    x2: 168.769,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1039",
    x1: 85.1499,
    y1: 128.037,
    x2: 85.1499,
    y2: 150.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1039",
    x1: 85.1502,
    y1: 91.355,
    x2: 85.1502,
    y2: 135.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1039",
    x1: 85.1481,
    y1: 40,
    x2: 85.1481,
    y2: 120.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1039",
    x1: 85.1501,
    y1: 142.709,
    x2: 85.1501,
    y2: 150.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1039",
    x1: 85.1481,
    y1: 76.6821,
    x2: 85.1481,
    y2: 84.0185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1039",
    x1: 118.163,
    y1: 69.9187,
    x2: 125.156,
    y2: 76.2615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_1039",
    x1: 118.163,
    y1: 56.3924,
    x2: 139.141,
    y2: 75.4209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_1039",
    x1: 118.163,
    y1: 42.8658,
    x2: 153.126,
    y2: 74.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26801_1039",
    x1: 121.956,
    y1: 133.65,
    x2: 157.147,
    y2: 163.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.1d32301fa16f784fc88668d991166ea4.svg";
export { ForwardRef as ReactComponent };